import { Link } from "@inertiajs/react";

const Footer = () => {
    return (
        <footer className="footer-main container-fluid footer py-3" id="footer">
            <div className="footer__contents row flex-column flex-sm-row justify-content-sm-center px-sm-2 pt-3">
                <div className="footer__contents-1 flex-grow-1 footer__icon col-auto my-2">
                    <img
                        className="img-fluid mb-3 mb-md-4"
                        src="/images/icon/acaraitu.png"
                        alt="Logo"
                    />
                    <div>
                        Plaza Aminta Lt. 5/504
                        <br />
                        Jl. TB Simatupang, Pondok Pinang, Kebayoran Lama
                        <br />
                        Jakarta Selatan, Indonesia - 12310
                        <br />
                        <br />
                        <a className="text-reset text-decoration-none" href="https://wa.me/6285186699917">
                        +6285186699917
                        </a>
                        <br />
                        center@acaraitu.id 
                    </div>
                </div>
                <div className="footer__contents-2 flex-fill col-auto row flex-column flex-md-row flex-nowrap">
                    <div className="flex-grow-1 col-auto my-2">
                        <h5 className="mb-2 mb-md-3 text-neutral-0">Tentang</h5>
                        <div className="my-1 my-md-2">
                            <a
                                href="/about"
                                className="text-decoration-none text-reset"
                            >
                                Tentang Kami
                            </a>
                        </div>
                        <div className="my-1 my-md-2">
                            <a
                                href="/pusat-bantuan"
                                className="text-decoration-none text-reset"
                            >
                                Pusat Bantuan
                            </a>
                        </div>
                        {/* <div className="my-1 my-md-2">
                            <a
                                href="/partnership"
                                className="text-decoration-none text-reset"
                            >
                                Partnership
                            </a>
                        </div> */}
                        {/* <div className="my-1 my-md-2">
                            <a
                                href="/internship"
                                className="text-decoration-none text-reset"
                            >
                                Internship
                            </a>
                        </div> */}
                        <div className="my-1 my-md-2">
                            <a
                                href="/privacy-policy"
                                className="text-decoration-none text-reset"
                            >
                                Kebijakan Privasi
                            </a>
                        </div>
                    
                    </div>
                    <div className="flex-grow-1 col-auto my-2">
                        <h5 className="mb-2 mb-md-3 text-neutral-0">Layanan</h5>
                        <div className="my-1 my-md-2">
                            <a
                                href="/event"
                                className="text-decoration-none text-reset"
                            >
                                Lihat Event
                            </a>
                        </div>
                        <div className="my-1 my-md-2">
                            <a
                                href="/mission"
                                className="text-decoration-none text-reset"
                            >
                                Lihat Mission
                            </a>
                        </div>
                        <div className="my-1 my-md-2">
                            <a
                                href="/cari-manpower"
                                className="text-decoration-none text-reset"
                            >
                                Lihat Manpower
                            </a>
                        </div>
                        {/* <div className="my-1 my-md-2">
                            <Link
                                href="/ecourse"
                                className="text-decoration-none text-reset"
                                >
                                Lihat E-Class Series
                            </Link>
                        </div> */}
                        {/* <div className="my-1 my-md-2">
                            <Link
                                href="/mission"
                                className="text-decoration-none text-reset"
                                >
                                Mission
                            </Link>
                        </div> */}
                        <div className="my-1 my-md-2">
                            <a
                                href="https://blog.metamata.id/"
                                className="text-decoration-none text-reset"
                                >
                                Blog
                            </a>
                        </div>
                        <div className="my-1 my-md-2">
                            <a
                                href="/qr-scanner"
                                className="text-decoration-none text-reset"
                                >
                                Cek Tiket
                            </a>
                        </div>
                    </div>
                    <div className="flex-grow-1 col-auto my-2">
                        <h5 className="mb-2 mb-md-3 text-neutral-0">Media Sosial</h5>
                        <div className="d-flex justify-content-start">
                            <a href="https://www.instagram.com/acaraitu.id/" target="_blank" className="text-decoration-none my-1 my-md-2 me-3">
                                <img src="/images/icon/instagram-circle.svg" alt="instagram" />
                            </a>
                            {/* <a href="https://www.tiktok.com/@metamata.id" target="_blank" className="text-decoration-none my-1 my-md-2 me-3">
                                <img src="/images/icon/tiktok-circle.svg" alt="tiktok" />
                            </a> */}
                            <a href="https://www.linkedin.com/company/pt-meta-mata-indonesia" target="_blank" className="text-decoration-none my-1 my-md-2 me-3">
                                <img src="/images/icon/linkedin-circle.svg" alt="linkedin" />
                            </a>
                            <a href="https://open.spotify.com/show/0OjxzzwslXabN87wTeM5Tv?si=7b_Guo7zS-OfPvHFDRfKOg&utm_source=copy-link" target="_blank" className="text-decoration-none my-1 my-md-2 me-3">
                                <img src="/images/icon/spotify-circle.svg" alt="spotify" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center" id="underFooter">
                    <hr/>
                    <span>
                        © {new Date().getFullYear()} PT Meta Mata Indonesia.
                        All Rights Reserved.
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
